import React from 'react';
import { DateTagProps } from './types';
import './DateTag.scss';

const DateTag: React.FC<DateTagProps> = ({
    date,
    icon,
    color = 'green',
    format = 'MMM DD',
    className = '',
    style = {},
    onClick,
}) => {
    // Format the date
    const formatDate = (dateValue: string | Date | number): string => {
        if (!dateValue) return '';

        const dateObj = typeof dateValue === 'string' || typeof dateValue === 'number'
            ? new Date(dateValue)
            : dateValue;

        if (isNaN(dateObj.getTime())) return '';

        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

        if (format === 'MMM DD') {
            const month = months[dateObj.getMonth()];
            const day = dateObj.getDate();
            return `${month} ${day}`;
        }

        // Default formatting
        return dateObj.toLocaleDateString();
    };

    const formattedDate = formatDate(date);

    if (!formattedDate) return null;

    return (
        <div
            className={`date-tag date-tag--${color} ${onClick ? 'date-tag--clickable' : ''} ${className}`}
            style={style}
            onClick={onClick}
        >
            <div className="date-tag__content">
                {icon && <span className="date-tag__icon">{icon}</span>}
                <span className="date-tag__text">{formattedDate}</span>
            </div>
        </div>
    );
};

export default DateTag;
